export const normalizeId = (str: string) =>
  str.toLowerCase().replace(/\s+/g, '-');
